import * as libFund from './fund';
import * as libFundVariant from './fundVariant';
import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
export const prefix = 'votes';
const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ fundID, variantID, voteID }) => {
    return libFundVariant.IDToName({ fundID, variantID }) + SEPARATOR + prefixWithSeparator + voteID;
};
export const validateName = genericValidateName([
    exactValidator(libFund.prefix),
    uuidValidator(),
    exactValidator(libFundVariant.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split(SEPARATOR);
    return {
        fundID: parts[1],
        variantID: parts[3],
        voteID: parts[5],
    };
};
export const fundVariantNameFromFundVariantVoteName = (name) => {
    const { fundID, variantID } = nameToID(name);
    return libFundVariant.IDToName({ fundID, variantID });
};
